export default __webpack_public_path__ + "static/social-tariff-acf9995bf3ab85cad1bf365381530686.png";